module.exports = __webpack_public_path__ + "static/media/circle.16d16e72.svg";